{
  "CUSTOM_ROLE": {
    "HEADER": "Custom Roles",
    "LEARN_MORE": "Learn more about custom roles",
    "DESCRIPTION": "Custom roles are roles that are created by the account owner or admin. These roles can be assigned to agents to define their access and permissions within the account. Custom roles can be created with specific permissions and access levels to suit the requirements of the organization.",
    "COUNT": "{n} custom role | {n} custom roles",
    "HEADER_BTN_TXT": "Add custom role",
    "LOADING": "Fetching custom roles...",
    "SEARCH_PLACEHOLDER": "Search custom roles...",
    "NO_RESULTS": "No custom roles found matching your search",
    "SEARCH_404": "Δεν υπάρχουν δεδομένα που να ταιριάζουν με αυτό το ερώτημα.",
    "PAYWALL": {
      "TITLE": "Upgrade to create custom roles",
      "AVAILABLE_ON": "The custom role feature is only available in the Business and Enterprise plans.",
      "UPGRADE_PROMPT": "Upgrade your plan to get access to advanced features like team management, automations, custom attributes, and more.",
      "UPGRADE_NOW": "Upgrade now",
      "CANCEL_ANYTIME": "You can change or cancel your plan anytime"
    },
    "ENTERPRISE_PAYWALL": {
      "AVAILABLE_ON": "The custom role feature is only available in the paid plans.",
      "UPGRADE_PROMPT": "Upgrade to a paid plan to access advanced features like audit logs, agent capacity, and more.",
      "ASK_ADMIN": "Please reach out to your administrator for the upgrade."
    },
    "LIST": {
      "404": "There are no custom roles available in this account.",
      "TITLE": "Manage custom roles",
      "DESC": "Custom roles are roles that are created by the account owner or admin. These roles can be assigned to agents to define their access and permissions within the account. Custom roles can be created with specific permissions and access levels to suit the requirements of the organization.",
      "TABLE_HEADER": {
        "NAME": "Όνομα",
        "DESCRIPTION": "Περιγραφή",
        "PERMISSIONS": "Permissions",
        "ACTIONS": "Ενέργειες"
      }
    },
    "PERMISSIONS": {
      "CONVERSATION_MANAGE": "Manage all conversations",
      "CONVERSATION_UNASSIGNED_MANAGE": "Manage unassigned conversations and those assigned to them",
      "CONVERSATION_PARTICIPATING_MANAGE": "Manage participating conversations and those assigned to them",
      "CONTACT_MANAGE": "Manage contacts",
      "REPORT_MANAGE": "Manage reports",
      "KNOWLEDGE_BASE_MANAGE": "Manage knowledge base"
    },
    "FORM": {
      "NAME": {
        "LABEL": "Όνομα",
        "PLACEHOLDER": "Please enter a name.",
        "ERROR": "Απαιτείται όνομα."
      },
      "DESCRIPTION": {
        "LABEL": "Περιγραφή",
        "PLACEHOLDER": "Please enter a description.",
        "ERROR": "Η περιγραφή απαιτείται."
      },
      "PERMISSIONS": {
        "LABEL": "Permissions",
        "ERROR": "Permissions are required."
      },
      "CANCEL_BUTTON_TEXT": "Άκυρο",
      "API": {
        "ERROR_MESSAGE": "Αδυναμία σύνδεσης με τον Woot Server, Παρακαλώ προσπαθήστε αργότερα"
      }
    },
    "ADD": {
      "TITLE": "Add custom role",
      "DESC": " Custom roles allows you to create roles with specific permissions and access levels to suit the requirements of the organization.",
      "SUBMIT": "Καταχώρηση",
      "API": {
        "SUCCESS_MESSAGE": "Custom role added successfully."
      }
    },
    "EDIT": {
      "BUTTON_TEXT": "Επεξεργασία",
      "TITLE": "Edit custom role",
      "DESC": " Custom roles allows you to create roles with specific permissions and access levels to suit the requirements of the organization.",
      "SUBMIT": "Ενημέρωση",
      "API": {
        "SUCCESS_MESSAGE": "Custom role updated successfully."
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Διαγραφή",
      "API": {
        "SUCCESS_MESSAGE": "Custom role deleted successfully.",
        "ERROR_MESSAGE": "Αδυναμία σύνδεσης με τον Woot Server, Παρακαλώ προσπαθήστε αργότερα"
      },
      "CONFIRM": {
        "TITLE": "Επιβεβαίωση Διαγραφής",
        "MESSAGE": "Είσαστε σίγουροι για την διαγραφή ",
        "YES": "Yes, delete ",
        "NO": "No, keep "
      }
    }
  }
}
